import React from 'react'
import Loader from 'react-loader-spinner'
import CheckIcon from 'react-icons/lib/fa/check'
import {Modal, ModalHeader, ModalBody, ListGroup, ListGroupItem} from 'reactstrap'
import Websocket from "react-websocket"
import {User} from '../../models'
import {WS_URL, getTeam} from "../../api"

class TeamSwitcherModal extends React.Component {
    constructor(props) {
        super(props)
        const {className, modal, toggle, teamIDs, currentTeamID, userID, token, onTeamSwitch} = this.props

        this.onTeamSwitchHandler = onTeamSwitch
        this.token = token
        this.teamIDs = teamIDs
        this.state = {
            modal,
            className,
            toggle,
            currentTeamID,
            userID,
            teams: [],
            loading: false
        }

        this.fetchTeamData = this.fetchTeamData.bind(this)
        this.handleWebSocketResponse = this.handleWebSocketResponse.bind(this)
        this.didSelectTeam = this.didSelectTeam.bind(this)
    }

    async componentDidMount() {
        if (this.token) {
            this.setState({loading: true})
            let teams = await this.fetchTeamData(this.teamIDs)
            this.setState({teams, loading: false})
        }
    }

    async componentWillReceiveProps(nextProps) {
        const {className, modal, toggle, teamIDs, currentTeamID, userID, token, onTeamSwitch} = nextProps
        let oldTeamIDs = this.teamIDs
        let teams = this.state.teams
        this.onTeamSwitchHandler = onTeamSwitch
        this.token = token

        if (teamIDs !== oldTeamIDs && this.token) {
            this.teamIDs = teamIDs
            teams = await this.fetchTeamData(this.teamIDs)
        }


        this.setState({
            modal,
            className,
            toggle,
            currentTeamID,
            userID,
            teams,
        })
    }

    async fetchTeamData(newTeamIDs) {
        let teams = []
        if (newTeamIDs && newTeamIDs.length) {
            for (let i = 0; i < newTeamIDs.length; i++) {
                try {
                    let teamID = newTeamIDs[i]
                    let teamObj = await getTeam(this.token, teamID, 'pico')
                    teams.push(teamObj)
                } catch (error) {
                    console.log(error)
                }
            }
        }
        return teams
    }


    async handleWebSocketResponse(data) {
        let {teams, currentTeamID} = this.state

        let result = JSON.parse(data)
        let user = User.fromAPIObject(result)
        let teamIDs = teams.map(t => t.id)

        if (teamIDs !== user.teams && this.token) {
            teams = await this.fetchTeamData(user.teams)
        }

        if (!user.teams || !user.teams.includes(currentTeamID)) {
            currentTeamID = user.activeTeam
        }

        this.setState({teams, currentTeamID})
    }

    didSelectTeam = (newTeamID) => () => {
        this.setState({currentTeamID: newTeamID})
        this.onTeamSwitchHandler(newTeamID)
    }

    render() {
        let {modal, loading, toggle, className, teams, currentTeamID, userID} = this.state

        return <Modal isOpen={modal} toggle={toggle} className={className}>
            <ModalHeader toggle={toggle}>Switch Teams</ModalHeader>
            <ModalBody>
                {(loading ?
                    <div className="align-content-center text-center justify-content-center">
                        <Loader type="TailSpin" color="orange" width={60} height={60}/>
                    </div>:
                        <ListGroup>
                            {(teams && teams.length ?
                                teams.map((team, idx) =>
                                    <ListGroupItem key={`user-team-${team.id}-${idx}`}
                                                   tag="button"
                                                   onClick={this.didSelectTeam(team.id)}
                                                   disabled={team.id === currentTeamID}
                                                   action>
                                        {(team.id === currentTeamID ?
                                            <span className="text-primary">
                                                <CheckIcon/>
                                            </span>:
                                                null)}
                                        &emsp;
                                        {team.name}
                                    </ListGroupItem>
                            ):
                                null)}
                        </ListGroup>)}
            </ModalBody>
            {(this.token && userID ?
                <Websocket url={`${WS_URL}/users/${userID}/?access_token=${this.token.accessToken}`}
                            onMessage={this.handleWebSocketResponse}/>:
                    null)}
        </Modal>
    }
}


export default TeamSwitcherModal



// WEBPACK FOOTER //
// ./src/components/ui/TeamSwitcherModal.js